import { Alert, Button, message } from "antd";
import { syncStatusConfig } from "../../employees/helpers/syncStatusConfig";
import { useContext, useState } from "react";
import { ScheduleOperation } from "../../../serviceoperation/ScheduleOperation";
import { CompanyContext } from "../../../contexts/company-context";

const renderSyncStatusAlert = (
  status: string | undefined,
  scheduleId: number
) => {
  const [isLoading, setIsLoading] = useState(false);
  const { selectedCompany } = useContext(CompanyContext);

  const handleReSync = () => {
    setIsLoading(true);
    const scheduleOps = new ScheduleOperation();
    scheduleOps
      .reSyncActivityAsync(
        selectedCompany?.corporationId as number,
        scheduleId as number
      )
      .then((x) => {
        setIsLoading(false);
        message.info(
          `The re-sync request has been queued. Please check back shortly for updated status.`
        );
      });
  };

  if (!["Failed", "Pending"].includes(status ?? "")) return null;

  const config = syncStatusConfig("TimeEntry")?.[status!];

  const getAlertType = (status: string) => {
    switch (status) {
      case "Failed":
        return "error";
      case "Pending":
        return "warning";
      case "Success":
        return "success";
      default:
        return "info";
    }
  };

  return (
    <Alert
      message={
        config?.tooltip ??
        "There was an error processing your request. Please try again later."
      }
      type={getAlertType(status!)}
      showIcon
      action={
        status === "Failed" && (
          <Button
            size="small"
            type="primary"
            onClick={handleReSync}
            loading={isLoading}
          >
            Re-Sync
          </Button>
        )
      }
    />
  );
};

export default renderSyncStatusAlert;
